import { render, staticRenderFns } from "./FieldFileDrop.vue?vue&type=template&id=6c933a30&scoped=true"
import script from "./FieldFileDrop.vue?vue&type=script&lang=ts"
export * from "./FieldFileDrop.vue?vue&type=script&lang=ts"
import style0 from "./FieldFileDrop.vue?vue&type=style&index=0&id=6c933a30&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6c933a30",
  null
  
)

export default component.exports